module.exports = __webpack_public_path__ + "img/logo-bendungan.9cb2a278.png";